import { render, staticRenderFns } from "./my-swiper-card.vue?vue&type=template&id=19f9c991&scoped=true&"
import script from "./my-swiper-card.vue?vue&type=script&lang=js&"
export * from "./my-swiper-card.vue?vue&type=script&lang=js&"
import style0 from "./my-swiper-card.vue?vue&type=style&index=0&id=19f9c991&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "19f9c991",
  null
  
)

export default component.exports